import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { server } from '../../server'; 

const Rooms = ({ refreshToken = 0 }) => {
  const [rooms, setRooms] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const currentProfile = useSelector(state => state.user.currentProfile) || sessionStorage.getItem('currentProfile') || 'User';

  useEffect(() => {
    const fetchRooms = async () => {
      try {
        setLoading(true);
        setError('');
        const response = await axios.get(`${server}/room/rooms?profile=${encodeURIComponent(currentProfile)}`, {
          withCredentials: true
        });
        setRooms(response.data.rooms || []);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch rooms');
        setLoading(false);
      }
    };

    fetchRooms();
  }, [currentProfile, refreshToken]);

  useEffect(() => {
    setCurrentIndex((index) => (rooms.length > 0 ? Math.min(index, rooms.length - 1) : 0));
  }, [rooms.length]);

  const handlePrev = () => {
    setCurrentIndex((index) => (index === 0 ? rooms.length - 1 : index - 1));
  };

  const handleNext = () => {
    setCurrentIndex((index) => (index === rooms.length - 1 ? 0 : index + 1));
  };

  if (loading) return <p>Loading rooms...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="rooms-container">
      <h2>My Rooms</h2>
      {rooms.length > 0 ? (
        <div className="rooms-carousel" aria-label="Community rooms">
          {rooms.length > 1 && (
            <button type="button" onClick={handlePrev} className="rooms-carousel-control left" aria-label="Previous room">
              &#10094;
            </button>
          )}
          <div className="rooms-carousel-track" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
            {rooms.map(room => (
              <Link to={`/rooms/${room.handle}`} key={room._id} className="rooms-carousel-item-link">
                <div
                  className="rooms-list-item"
                  style={{
                    backgroundImage: room.banner?.url ? `url(${room.banner.url})` : undefined,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                >
                  <div className="rooms-list-item-overlay">
                    <div className="rooms-carousel-name">{room.name}</div>
                    <div className="rooms-carousel-description">{room.description}</div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
          {rooms.length > 1 && (
            <button type="button" onClick={handleNext} className="rooms-carousel-control right" aria-label="Next room">
              &#10095;
            </button>
          )}
        </div>
      ) : (
        <p>No rooms created yet.</p>
      )}
    </div>
  );
};

export default Rooms;



